import { useCallback } from "react";
import axios from "../api/axios";

const API_BASE = "/students/report";

export const useStudentReports = () => {
  const fetchSummary = useCallback(
    (filters) =>
      axios
        .get(`${API_BASE}/summary`, { params: filters })
        .then((res) => res.data),
    []
  );

  const fetchBranchGradeBreakdown = useCallback(
    (filters) =>
      axios
        .get(`${API_BASE}/branch-grade-breakdown`, { params: filters })
        .then((res) => res.data),
    []
  );

  const fetchPendingStudents = useCallback(
    (filters) =>
      axios
        .get(`${API_BASE}/pending`, { params: filters })
        .then((res) => res.data),
    []
  );

  const fetchDuplicateStudents = useCallback(
    (filters) =>
      axios
        .get(`${API_BASE}/duplicates`, { params: filters })
        .then((res) => res.data),
    []
  );

  return {
    fetchSummary,
    fetchBranchGradeBreakdown,
    fetchPendingStudents,
    fetchDuplicateStudents,
  };
};
